import consts from '../consts'

export default {
  getTicketStatus(status) {
    return consts.TICKET_STATUS.find(ts => ts.id === status) || {color: 'blue', title: 'Sans titre', icon: 'check'}
  }
}
